import '../LandingPage.css';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { auth, provider } from '../firebase';
import { signInWithPopup } from 'firebase/auth';
import SiteService from './SiteService';
import FreeConsumptionStepper from './Rating/FreeConsumptionStepper';
import {
  AboutSubMeterSection,
  CommonMistakesSection,
  FaqSection,
  LateReadingExampleSection,
  RecordManagementSection,
  TieredTariffExampleSection,
  TimeOfUseExampleSection,
  UseCasesSection,
  WhySimpleRatioIsNotEnoughSection
} from './LandingContentSections';

const initializedAdElements = new WeakSet();
const AdSenseUnit = () => {
  const insRef = useRef(null);
  useEffect(() => {
    const element = insRef.current;
    if (!element || initializedAdElements.has(element) || element.dataset.adsbygoogleStatus) return;
    initializedAdElements.add(element);
    try { window.adsbygoogle = window.adsbygoogle || []; window.adsbygoogle.push({}); }
    catch (error) { console.debug('AdSense birimi başlatılamadı', error); }
  }, []);
  return <section className="adsense-section" aria-label="Sponsorlu reklam"><div className="adsense-label">Sponsorlu</div><ins ref={insRef} className="adsbygoogle adsense-landing" style={{ display: 'block' }} data-ad-client="ca-pub-7115067061462299" data-ad-slot="6411716550" data-ad-format="auto" data-full-width-responsive="true" /></section>;
};

const LandingPage = () => {
  const navigate = useNavigate();
  const [isCalculationReady, setIsCalculationReady] = useState(false);
  const handleCalculationResultReady = useCallback(() => setIsCalculationReady(true), []);
  const handleLogin = async () => {
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      await SiteService.addUser({ uid: user.uid, email: user.email, displayName: user.displayName, provider: 'google' });
      navigate('/');
    } catch (error) { console.error('Google ile giriş yapılamadı:', error); }
  };
  return <div className="landing-page"><main className="landing-content">
    <header className="landing-hero text-center mb-4"><span className="hero-kicker">Elektrik paylaşımını anlaşılır hâle getirin</span><h1 className="fw-bold display-5">Süzme Sayaç Hesaplama</h1><p className="lead text-muted">Ortak elektrik faturasını tarife ve sayaç tüketimlerini dikkate alarak anlaşılır biçimde paylaştırın.</p><div className="hero-pills" aria-label="Öne çıkan özellikler"><span>Kademeli tarife</span><span>Çok zamanlı tüketim</span><span>Şeffaf paylaşım</span></div><p className="mt-3"><Link to="/elektrik-faturasi-hesaplama">Sadece kendi elektrik faturanızı hesaplamak için elektrik faturası hesaplama aracını açın →</Link></p></header>
    <AboutSubMeterSection />
    <section className="calculator-section" aria-labelledby="calculator-title"><h2 id="calculator-title">Elektrik faturası paylaşım aracı</h2><FreeConsumptionStepper onCalculationResultReady={handleCalculationResultReady} /></section>
    {isCalculationReady && <AdSenseUnit />}
    <WhySimpleRatioIsNotEnoughSection />
    <TieredTariffExampleSection />
    <TimeOfUseExampleSection />
    <LateReadingExampleSection />
    <RecordManagementSection />
    <UseCasesSection />
    <CommonMistakesSection />
    <FaqSection />
    <section className="login-section text-center" aria-labelledby="login-title"><h2 id="login-title">Kayıtlarınızı düzenli tutun</h2><p className="text-muted">Sayaçlarınızı tanımlamak, önceki okumaları saklamak ve dönem sonuçlarına yeniden ulaşmak için Google hesabınızla giriş yapabilirsiniz.</p><button className="btn btn-primary" onClick={handleLogin}>Google ile Giriş Yap</button></section>
    <section className="mobile-app-section" aria-labelledby="mobile-title">
      <div className="mobile-app-copy"><span className="mobile-app-kicker">Mobil uygulama</span><h2 id="mobile-title">Süzme Sayaç cebinizde</h2><p>Sayaç kayıtlarınıza ve hesaplamalarınıza mobil cihazınızdan ulaşın.</p></div>
      <div className="mobile-store-links">
        <a href="https://apps.apple.com/app/s%C3%BCzme-saya%C3%A7/id6751746732" target="_blank" rel="noopener noreferrer" aria-label="Süzme Sayaç uygulamasını App Store'da aç"><img src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/tr-tr?size=250x83&amp;releaseDate=1727913600" alt="App Store'dan indir" /></a>
        <div className="store-coming-soon" aria-label="Google Play sürümü çok yakında"><img src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg" alt="Google Play" /><span>ÇOK YAKINDA</span></div>
      </div>
    </section>
    <footer className="landing-footer"><nav aria-label="Yasal ve destek bağlantıları"><Link to="/privacy">Gizlilik Politikası</Link><Link to="/terms">Kullanım Koşulları</Link><Link to="/support">Destek ve İletişim</Link></nav><p>© {new Date().getFullYear()} Süzme Sayaç. Tüm hakları saklıdır.</p></footer>
  </main></div>;
};
export default LandingPage;
